<template>
  <v-dialog v-model="localDialog" width="40%" @update:modelValue="updateDialog" transition=""persistent :open-delay="0" :close-delay="0">
    <v-card>
        <v-card-title class="text-h6">
            <span>{{ isEntryMode ? 'Add SubModule' : 'Update SubModule' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form @submit.prevent="submit" ref="subModuleSetup">
              <v-row>
                  <v-col cols="12">   
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="module_id.value.value"
                        :items="getModuleList.filter(item=> item.status == 1)"
                        :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
                        item-value="id"
                        :error-messages="module_id.errorMessage.value"
                        clearable                        
                      >
                        <template #label>
                          Module <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete> 

                      <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="name.value.value"
                          :error-messages="name.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          Name <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="sl.value.value"
                          :error-messages="sl.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          Serial <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="icon.value.value"
                        :error-messages="icon.errorMessage.value"
                        clearable
                      >
                        <template #label>
                          Icon <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>    

                      <v-card-actions>
                        <v-row class="px-4">
                          <v-col cols="6">
                            <v-checkbox                            
                              label="Active"
                              v-model="status.value.value"
                              :error-messages="status.errorMessage.value"
                              density="compact"
                              variant="outlined"
                              hide-details
                              single-line
                              color="primary"
                              value="1"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="6">
                            <v-checkbox                            
                              label="Is App"
                              v-model="is_app.value.value"
                              :error-messages="is_app.errorMessage.value"
                              density="compact"
                              variant="outlined"
                              hide-details
                              single-line
                              color="primary"
                              value="1"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                      <input v-model="submodule_id.value.value" type="hidden">                              
                  </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"  
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </v-card-text>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'

export default {
  name: 'ModuleSetup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        name: '',
        icon: '',
        sl: '',
        status: '1',
        is_app: '1',
        module_id: null,
        submodule_id: null
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      selectedImage: null,
      errorMessages: '',
      preview: '/src/assets/no_preview.jpeg',
      loading: false,
      isEntryMode: true,
    }
  },
  computed: {
    getModuleList() {
      return this.$store.getters.getModuleList;
    },
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.name.setValue(newData.name || '', false);
        this.icon.setValue(newData.icon || '', false);
        this.sl.setValue(newData.sl || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.is_app.setValue(String(newData.is_app) || '1', false);
        this.module_id.setValue(newData.module_id || '', false);
        this.submodule_id.setValue(newData.id || '', false);
      },
    }
    
  },
  created() {
     if(this.$store.getters.getModuleList.length == 0){
          this.loading = true;
            this.$store.dispatch('getModuleList').then((response) => {
              this.loading = false;
          })
      };
  },
  methods: {
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          name: yup.string().min(1).max(50).required().trim().label('Name'),
          icon: yup.string().min(1).max(50).required().trim().label('Icon'),
          sl: yup.number().positive().integer().required().label('SL'),
          module_id: yup.number().positive().integer().required().label('Module Name'),
          submodule_id: yup.number().positive().integer().nullable().label('SubModule Name'),
      }),

    });

    const name = useField('name');
    const icon = useField('icon');
    const sl = useField('sl');
    const status = useField('status');
    const is_app = useField('is_app');
    const module_id = useField('module_id');
    const submodule_id = useField('submodule_id');
    const errorMessages  = ref('');
    const loading  = ref('');
    const store = useStore();

    const submit = handleSubmit((values) => {
        store.dispatch("saveUpdateSubModuleSetup", values)
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getSubModuleList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      name,
      icon,
      sl,
      status,
      is_app,
      errorMessages,
      module_id,
      submodule_id,
      resetForm,
      loading
    }
  },
  mounted() {
  }
}
</script>

